import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Ctrs } from '@/common/js/fscroll'
import dayjs from 'dayjs'
import i18n from './lang'

// import './assets/icons' // icon
import router from './router'
import store from '@/store'
import App from './App'
import { axiosApi } from '@/common/js/api.js'
import { parseTime, tHght } from '@/utils/index'
Vue.use(ElementUI)
import { Message } from 'element-ui'
import './assets/css/global.less'
import './assets/css/modify.less'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import md5 from 'js-md5'

import { TITLE } from '../settings'

Ctrs()

// 后端接口正式地址
// axios.defaults.baseURL = 'https://api.erp.transecs.com/api/v1'

// 后端接口测试地址
axios.defaults.baseURL = 'https://api.erp.transecs.com/api/v1/'
// axios.defaults.baseURL = 'http://oms.com/api/v1/'//(calvin测)

// (弃用)
// axios.defaults.baseURL = 'http://test.transecs.com/api/v1/'
// axios.defaults.baseURL = 'http://wm-api.transecs.com/api/v1/'

axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 60000

// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 在最后必须return config
  config.headers.Authorization = 'Bearer ' + window.sessionStorage.getItem('token')
  config.headers['Authorization-Ptn-Code'] = window.sessionStorage.getItem('ptnCode')

  return config
})

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    return response
  },
  function(error) {
    const err = error.response.data
    if (err.message == '请重新登录' && err.meta.status == 400) {
      Message({
        type: 'error',
        message: err.message
      })
      window.sessionStorage.clear()
      location.reload()
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios
Vue.prototype.axiosApi = axiosApi
Vue.prototype.tHght = tHght
Vue.prototype.dayjs = dayjs
Vue.prototype.$FileSaver = FileSaver
Vue.prototype.$XLSX = XLSX
Vue.prototype.$md5 = md5

Vue.config.productionTip = false

Vue.filter('translateFlag', function(value, list) {
  let curr
  for (let item of list) {
    if (parseInt(item.status) === parseInt(value)) {
      curr = item.label
    }
  }
  return curr
})
Vue.filter('translateNumber', function(value, list) {
  let curr
  value = parseInt(value)
  for (let item of list) {
    if (parseInt(item.status) === parseInt(value)) {
      curr = item.label
    }
  }
  return curr
})
Vue.filter('translateCodeName', function(code, list) {
  let curr
  for (let item of list) {
    if (item.code === code) {
      return item.name
    }
  }
  return curr
})
Vue.filter('translateCodeNameForNumber', function(code, list) {
  code = parseInt(code)
  let curr
  for (let item of list) {
    if (item.code === code) {
      return item.name
    }
  }
  return curr
})
Vue.filter('translateLabelValue', function(value, list) {
  for (let item of list) {
    if (item.value === value) {
      return item.label
    }
  }
})
Vue.filter('translateLabelName', function(value, list) {
  for (let item of list) {
    if (item.ptnCode === value) {
      return item.ptnName
    }
  }
})
Vue.filter('translateTF', function(value) {
  if (value === 'F') return false
  if (value === 'T') return true
})
Vue.filter('parseTime', function(value) {
  if (!value) return
  var time = parseTime(value)
  return time
})
Vue.filter('translateLockFlag', function(value) {
  return value === 'T' ? 'el-icon-lock' : ''
})
Vue.filter('_parseInt', function(value) {
  return parseInt(value)
})
Vue.filter('joinPtnName', function(value) {
  if (value.length == 2) {
    value = value.split('')

    return value.join('\xa0\xa0')
  }
  return value
})

// const m = monitorZoom()
// if (window.screen.width * window.devicePixelRatio >= 3840) {
//   document.body.style.zoom = 100 / (Number(m) / 2)
// } else {
//   document.body.style.zoom = 100 / Number(m)
// }

// translateLockFlag(value) {
//   return value === "T" ? "el-icon-lock" : "";
//   return value;
// },

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`
  } else {
    var systemName = window.sessionStorage.getItem('systemName')
    document.title = systemName || `${TITLE().title}`
  }
  const path = window.sessionStorage.getItem('activePath')
  if(to.fullPath == '/login' && path && path != 'null'){
    next(path)
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js